import React from "react";
import EnquiriesInbox from "./EnquiriesInbox";
import * as api from "../../../apis/Enquiries";

// HQ admin scope — read-only oversight across all branches. The shared
// inbox hides reply/status/compose UI when scope !== "branch".
const adminApi = {
  listEnquiries: (params) => api.enquiries(params),
  getEnquiry: (id) => api.enquiry(id),
  // Stubs so the shared component can call them without crashing if it
  // ever did; the UI doesn't surface these for admin scope.
  reply: () => Promise.resolve({ status: false }),
  setStatus: () => Promise.resolve({ status: false }),
  createAnnouncement: () => Promise.resolve({ status: false }),
  uploadAttachment: () => Promise.resolve({ status: false }),
};

const AdminEnquiries = () => <EnquiriesInbox api={adminApi} scope="admin" />;

export default AdminEnquiries;
